import CustomTable from '@myComponents/CustomTable';
import { FIND_AUDIO_HISTORY } from '../../graphql/Query/roadshistory';
import { useQuery } from '@apollo/client';
import { columns } from './columns';
import moment from 'moment';
import { useState } from 'react';
import Sidebar from './Sidebar';

const variables = {
  search: {
    dates: [moment().utc().subtract(30, 'days').toDate(), moment().utc().toDate()],
    q: '',
    perPage: 10,
    page: 1
  }
};

const AudioHistoryList = () => {
  const { data, refetch, loading } = useQuery(FIND_AUDIO_HISTORY, {
    variables
  });
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedAudio, setSelectedAudio] = useState(null);

  const toggleSidebar = (row) => {
    if (row) {
      setSelectedAudio(row);
    }
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <CustomTable
      loading={loading}
      store={data?.findAudioHistoryPaginate?.docs || []}
      data={{ ...data?.findAudioHistoryPaginate, docs: undefined }}
      refetch={refetch}
      filterOptions={{
        types: [
          {
            id: 'audio_history_dates',
            name: 'dates',
            placeholder: 'Seleccionar Fecha',
            type: 'rangepicker'
          }
        ]
      }}
      variables={variables}
      columns={columns({ toggleSidebar })}
      sidebar={
        <Sidebar
          open={sidebarOpen}
          toggleSidebar={toggleSidebar}
          selectedAudio={selectedAudio}
        />
      }
    />
  );
};

export default AudioHistoryList;
